import { Outlet } from "react-router-dom";
import { ComponentType, Suspense } from "react";
import { Alert } from "@/components/ui/alert.tsx";
import withAppProviders, { ComponentProps } from "@/withAppProviders.tsx";
import { Toaster } from "@/components/ui/toaster.tsx";

function App() {
    return (
        <Suspense>
            <div className="flex w-full justify-center">
                <div className="w-full max-w-screen-xl">
                    <Outlet />
                </div>
            </div>
            <Alert />
            <Toaster />
        </Suspense>
    );
}

export default withAppProviders(App as ComponentType<ComponentProps>);
